import { routerIsLinkActive } from "../../utils/router-is-link-active/router-is-link-active";
import { useUnsafeRouterContext } from "../use-unsafe-router-context/use-unsafe-router-context";
import { NavLinkProps, To } from "react-router-dom";

export const useRouterIsLinkActive = (to: To, options?: NavLinkProps): boolean => {
    const context = useUnsafeRouterContext()
    return routerIsLinkActive(to, context, options)
}